import { render, staticRenderFns } from "./keteranganIjin.vue?vue&type=template&id=477c95ec"
import script from "./keteranganIjin.vue?vue&type=script&lang=js"
export * from "./keteranganIjin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports